import { useState, useEffect } from "react";
import Button from "../../../components/Button";
import DialogComponent from "../../../components/DialogComponent";
import CancelAddCard from "./components/cancel";
import SendCard from "./components/send";
import Step_1 from "./components/step_1";
import Step_2 from "./components/step_2";
import Step_3 from "./components/step_3";
import { useAppDispatch, useAppSelector } from "../../../hooks/redux";
import { addItem, addItemIdle, getItems } from "../../spItems/actions";
import Loading from "src/components/Loading";
import { uploadFile } from "src/api/requests/uploadFile";
import { updateFile } from "../../../api/requests/updateFile";
import {
  approversCardDocumentListName,
  approversListName,
  documentByCardFilesLibName,
  documentCodeIndexesListName,
  emailsSender,
  equipmentsByDocumentListName,
  equipmentsListName,
  historyByDocumentListName,
  historyChangeFieldsDocumentListName,
  linesListName,
  MDDocumentsFiles,
  myDocumentsListName,
  paramsListName,
  siteUrl,
  templatesLibName,
} from "src/api/config";
import { selectCurrentUser, selectUsers } from "src/modules/users/selector";
import {
  selectItems,
  selectAddStatus,
  selectJustAddedItem,
} from "src/modules/spItems/selectors";
import { useNavigate } from "react-router";
import moment from "moment";
import { emailAPI } from "src/utils/api.utils";
import { addItemRequest, getItemsRequest } from "src/modules/spItems/api";
import { FlexCol } from "src/utils/flexLayouts";
import { checkApprovers, setMultiApprove } from "../constants";
import { notificationsListName } from "src/api/config/notifications.config";
import {
  docApprovers,
  docStatuses,
  notificationStatuses,
} from "src/api/config/systemSwitch";
const { sendEmail } = emailAPI();

function AddCard() {
  const [open, setOpen] = useState(false);
  const [closeAllModals, setCloseAllModals] = useState(false);
  const addStatus = useAppSelector((state) =>
    selectAddStatus(state, myDocumentsListName)
  );
  const idAddCard = useAppSelector((state) =>
    selectJustAddedItem(state, myDocumentsListName)
  );
  const [files, setFiles] = useState([]);
  const [equipments, setEquipments] = useState([]);
  const [approvers, setApprovers] = useState<any>({});
  const [titleNewDocument, setTitleNewDocument] = useState("");
  const [comment, setComment] = useState("");
  const currentUser = useAppSelector(selectCurrentUser);
  const approversList = useAppSelector((state) =>
    selectItems(state, approversListName)
  );
  const users: any = useAppSelector(selectUsers);
  const [loading, setLoading] = useState<any>({
    add: false,
    approvers: false,
    equipments: false,
    document: false,
  });
  const [code, setCode] = useState("");
  const repeatEmails: any = useAppSelector((state) =>
    selectItems(state, paramsListName)
  );

  useEffect(() => {
    console.log(" --- approvers: ", approvers);
  }, [approvers]);

  useEffect(() => {
    console.log(" --- approversList: ", approversList);
  }, [approversList]);

  useEffect(() => {
    console.log(" --- localStorage: ", localStorage);
  }, [localStorage]);

  useEffect(() => {
    if (
      idAddCard &&
      Object.keys(approvers).length &&
      !loading.approvers &&
      approversList.length > 0
    ) {
      const localApproversDependencies =
        localStorage.getItem("approversDependencies") || "";
      const approversDependencies = JSON.parse(localApproversDependencies);
      localStorage.setItem("approversDependencies", "");
      let dataApproversCard: any = [],
        dataHistoryCard: any = [],
        dataHistoryCardSend: any = [],
        dataApproversCardSend: any = [],
        historyFields: any = {},
        dataNotificationCard: any = [];
      dataApproversCard = [
        ...dataApproversCard,
        {
          Title: `Approver card # ${idAddCard}`,
          Approvers: [currentUser.email],
          Document: idAddCard,
          Group: docApprovers.Creater,
          Statuses: [docStatuses.created, docStatuses.sendApproval],
        },
      ];
      dataHistoryCard = [
        ...dataHistoryCard,
        {
          Title: `History card # ${idAddCard}`,
          Comment: comment,
          Approvers: [currentUser.email],
          DocumentID: idAddCard,
          ApprovalGroup: docApprovers.Creater,
          Statuses: [docStatuses.created, docStatuses.sendApproval],
        },
      ];
      historyFields = {
        Title: `History fields card # ${idAddCard}`,
        DocumentID: idAddCard,
        Statuses: [docStatuses.created, docStatuses.sendApproval],
        Comment: comment,
      };
      Object.keys(approvers).map((key: string, idx: number) => {
        const people: { avatar: string; label: string; value: string }[] =
          (Array.isArray(approvers[key]) &&
            approvers[key].length > 0 &&
            approvers[key]) ||
          [];
        let sendPeople: string[] = [];
        people.map((user) => {
          if (user.value) {
            sendPeople = [...sendPeople, user.value.toLowerCase()];
          }
        });
        const groupID =
          approversList.filter((item) => item.Code === key).length > 0 &&
          approversList.filter((item) => item.Code === key)[0]["ID"];
        const order =
          (approversList.filter((item) => item.Code === key).length > 0 &&
            approversList.filter((item) => item.Code === key)[0][
            "SortColumn"
            ]) ||
          0;
        if (sendPeople.length > 0) {
          if (checkApprovers(groupID, approversDependencies)) {
            sendPeople.forEach((email: any) => {
              dataNotificationCard = [
                ...dataNotificationCard,
                {
                  Title: `Согласовать # ${idAddCard}`,
                  ReviewDate: moment(new Date())
                    .add(
                      Number(
                        repeatEmails
                          .find(
                            (param: any) => param.Key === "documentsApproveDays"
                          )
                        ["Value"].trim()
                      ),
                      "days"
                    )
                    .toDate(),
                  AuthorComment: comment,
                  DocumentCode: code,
                  Document: idAddCard,
                  NotificationType: notificationStatuses.approval, // Согласовать
                  Employee: email.toLowerCase(),
                  EmployeeEmail: email.toLowerCase(),
                  AuthorEmail: currentUser.email.toLowerCase(),
                  Completed: new Date(),
                },
              ];
            });
            if (emailsSender) {
              let emailsHanleArr: any = [];
              const minutes = Number(
                repeatEmails
                  .find((param: any) => param.Key === "documentApprove")
                ["Value"].trim()
              );
              const dateSendEmailsArr = [
                moment(new Date()).clone().subtract(12, "hours").toDate(),
                moment(new Date()).clone().add(minutes, "m").toDate(),
              ];
              dateSendEmailsArr.forEach((date: Date, idxDate: number) => {
                sendPeople.forEach((email: any) => {
                  const emailBody = {
                    Body: `Здравствуйте ${users[email.toLowerCase()] &&
                      users[email.toLowerCase()]["displayName"]
                      },<br/><br/>Прочитайте следующий документ и подтвердите факт его согласования:<br/><br/><a href="${siteUrl}/dashboard/1?documentCard=${idAddCard}">${titleNewDocument}</a><br/><br/>Срок согласования: <span${(idxDate === 1 && ` style="color:red;"`) || ""
                      }>${moment(new Date())
                        .add(
                          Number(
                            repeatEmails
                              .find(
                                (param: any) =>
                                  param.Key === "documentsApproveDays"
                              )
                            ["Value"].trim()
                          ),
                          "days"
                        )
                        .format("DD.MM.YYYY")}</span>`,
                    DateToBeSentAt: date,
                    Title: "Мои Документы | Согласование документа",
                    Subject: "Мои Документы | Согласование документа",
                    Recepients: email,
                    CheckDoc: String(idAddCard),
                    RepeatAt: (idxDate === 1 && minutes) || 0,
                  };
                  emailsHanleArr = [...emailsHanleArr, sendEmail(emailBody)];
                });
              });
              Promise.all(emailsHanleArr);
            }
          }
          console.log("--- AddCard approversDependencies: ", approversDependencies);
          dataApproversCard = [
            ...dataApproversCard,
            {
              Title: `Approver card # ${idAddCard}`,
              Approvers: sendPeople,
              order: order,
              Document: idAddCard,
              Group: groupID,
              Statuses: [docStatuses.waitApproval],
              Queue: checkApprovers(groupID, approversDependencies),
              MultiApprove: setMultiApprove(groupID, approversDependencies),
            },
          ];
          dataHistoryCard = [
            ...dataHistoryCard,
            {
              Title: `History card # ${idAddCard}`,
              Comment: "",
              order: order,
              Approvers: sendPeople,
              DocumentID: idAddCard,
              ChangeDate: new Date(),
              ApprovalGroup: groupID,
              Statuses: [docStatuses.waitApproval],
            },
          ];

          dataApproversCard.sort(function (a: any, b: any) {
            return a.order - b.order;
          });

          dataHistoryCard.sort(function (a: any, b: any) {
            return a.order - b.order;
          });

          dataHistoryCardSend = dataHistoryCard.map((item: any) => {
            delete item.order;
            return { ...item };
          });

          dataApproversCardSend = dataApproversCard.map((item: any) => {
            delete item.order;
            return { ...item };
          });
        }
      });
      Promise.all([
        addItemRequest({
          listName: approversCardDocumentListName,
          bodyArr: dataApproversCardSend,
          body: dataApproversCardSend[0],
        }),
        addItemRequest({
          listName: historyChangeFieldsDocumentListName,
          body: historyFields,
        }),
        addItemRequest({
          listName: historyByDocumentListName,
          body: dataHistoryCardSend[0],
          bodyArr: dataHistoryCardSend,
        }),
        addItemRequest({
          listName: notificationsListName,
          body: dataNotificationCard[0],
          bodyArr: dataNotificationCard,
        }),
      ]).then((values) => {
        setLoading((loading: any) => {
          return { ...loading, approvers: true };
        });
      });
    }
  }, [idAddCard, approvers, approversList]);

  useEffect(() => {
    if (addStatus === "SUCCESS" && idAddCard) {
      setLoading((loading: any) => {
        return { ...loading, add: true };
      });
    }
  }, [addStatus, idAddCard]);

  useEffect(() => {
    if (idAddCard) {
      if (equipments.length > 0) {
        let sendDataEquipments: any = [];
        for (let i = 0; i < equipments.length; i++) {
          sendDataEquipments = [
            ...sendDataEquipments,
            {
              Title: `Document card #${idAddCard}`,
              Line: equipments[i]["Line"] && equipments[i]["Line"]["id"],
              Equipment: equipments[i]["SAP"] && equipments[i]["SAP"]["ID"],
              Document: idAddCard,
            },
          ];
        }
        if (sendDataEquipments.length > 0) {
          addItemRequest({
            listName: equipmentsByDocumentListName,
            body: sendDataEquipments[0],
            bodyArr: sendDataEquipments,
          }).then(() => {
            setLoading((loading: any) => {
              return { ...loading, equipments: true };
            });
          });
        }
      } else {
        setLoading((loading: any) => {
          return { ...loading, equipments: true };
        });
      }
    }
  }, [idAddCard, equipments]);

  useEffect(() => {
    if (idAddCard && files.length > 0) {
      uploadFile(
        files[0],
        documentByCardFilesLibName,
        MDDocumentsFiles.idFolder,
        MDDocumentsFiles.apiStrapi,
        MDDocumentsFiles.createElemInStrapi,
        titleNewDocument
      ).then((objUploadFile: any) => {
        updateFile(
          documentByCardFilesLibName,
          { CardID: idAddCard, ID: objUploadFile["id"] },
          MDDocumentsFiles.apiStrapi,
          { CardID: idAddCard, id: objUploadFile["id"] }
        ).then((idFileUpdated: any) => {
          setLoading((loading: any) => {
            return { ...loading, document: true };
          });
        });
      });
    }
  }, [idAddCard, files]);

  const dialogToggle = (b: boolean) => {
    setOpen(b);
  };

  useEffect(() => {
    setOpen(false);
  }, [closeAllModals]);

  return (
    <>
      {(currentUser.isAdmin ||
        currentUser.isCollectionAdmin ||
        currentUser.isCollectionEditor) && (
          <Button
            open={open}
            setOpen={setOpen}
            typeIcon="add"
            classBg="btn-dark"
            text="Создать документ"
            icon={true}
          />
        )}
      {open && (
        <AddDialog
          open={open}
          toggleDialog={dialogToggle}
          setFiles={setFiles}
          setEquipments={setEquipments}
          closeAllModals={closeAllModals}
          setApprovers={setApprovers}
          approvers={approvers}
          setComment={setComment}
          comment={comment}
          setCloseAllModals={setCloseAllModals}
          setCode={setCode}
          loading={loading}
          setTitleNewDocument={setTitleNewDocument}
          setLoading={setLoading}
        />
      )}
    </>
  );
}

export default AddCard;

function AddDialog({
  open,
  toggleDialog,
  closeAllModals,
  setCloseAllModals,
  setFiles,
  setEquipments,
  setApprovers,
  approvers,
  comment,
  setComment,
  setCode,
  setTitleNewDocument,
  loading,
  setLoading,
}: {
  open: boolean;
  toggleDialog: (b: boolean) => void;
  closeAllModals: boolean;
  setCloseAllModals: (b: boolean) => void;
  setEquipments: (arr: any) => void;
  setFiles: (arr: any) => void;
  setApprovers: (arr: any) => void;
  approvers: any;
  comment: string;
  setComment: (str: string) => void;
  setCode: (str: string) => void;
  setTitleNewDocument: (str: string) => void;
  loading: any;
  setLoading: any;
}) {
  const [openCancelAddCard, setOpenCancelAddCard] = useState(false);
  const [openSendCard, setOpenSendCard] = useState(false);
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState<any>(null);
  const dispatch = useAppDispatch();
  const [statusTemplates, setStatusTemplates] = useState("IDLE");
  const [templates, setTemplates] = useState<any>([]);
  const [backStep, setBackStep] = useState(false);
  const [defaultValues, setDefaultValues] = useState<any>(null);
  const [indexDocument, setIndexDocument] = useState("");
  const [indexDocumentNumber, setIndexDocumentNumber] = useState(0);
  const currentUser = useAppSelector(selectCurrentUser);
  const navigate = useNavigate();
  const [customLoading, setCustomLoading] = useState(false);
  const [hideCloseIcon, setHideCloseIcon] = useState(false);

  const dialogToggleCancelAddCard = (b: boolean) => {
    setOpenCancelAddCard(b);
  };

  const dialogToggleSendCard = (b: boolean) => {
    setOpenSendCard(b);
  };

  useEffect(() => {
    setOpenCancelAddCard(false);
    setOpenSendCard(false);
  }, [closeAllModals]);

  useEffect(() => {
    if (formData && Object.keys(formData).length > 0) {
      setStep(step + 1);
    }
  }, [formData]);

  useEffect(() => {
    if (backStep) {
      setApprovers({});
      setStep(step - 1);
      let code = "",
        index = "";
      const codeArr = formData.Code.split(".");
      index = codeArr[codeArr.length - 1];
      code = formData.Code.slice(0, -(index.length + 1));
      let tempFormData = { ...formData };
      tempFormData = { ...tempFormData, Code: code };
      tempFormData = { ...tempFormData, Index: index };
      setIndexDocument(index);
      setDefaultValues(tempFormData);
      setFormData(null);
      setBackStep(false);
    }
  }, [backStep]);

  useEffect(() => {
    if (Object.keys(approvers).length > 0) {
      setOpenSendCard(true);
    }
  }, [approvers]);

  const addCardHandle = () => {
    setCustomLoading(true);
    setHideCloseIcon(true);
    let linesStrIds = "",
      equipmentsStrIds = "";
    let code = "",
      index = "";
    const codeArr = formData.Code.split(".");
    index = codeArr[codeArr.length - 1];
    code = formData.Code.slice(0, -(index.length + 1));
    console.log("formData: ", formData);
    const sendData = {
      Code: code,
      Collection: formData.Collection.id,
      Department: formData.Department.id,
      Sector: formData.Sector.id,
      Process: formData.Process.id,
      DocType: formData.DocType.id,
      ResponsibleForRevision: formData.ResponsibleForRevision[0]["value"],
      DateForRevision:
        (typeof formData.DateForRevision.startDate === "string" &&
          new Date(formData.DateForRevision.startDate)) ||
        formData.DateForRevision.startDate,
      Critical: formData.Critical.id,
      Path: formData.Path,
      Title: formData.Title,
      Lines: "",
      PublicationDate: moment(new Date()).add(7, "d").toDate(),
      Equipments: "",
      Status: docStatuses.approval, // Список Statuses - На согласовании
      Index: index,
      AuthorEmail: currentUser.email.toLowerCase(),
      ResponsibleForRevisionEmail:
        formData.ResponsibleForRevision[0]["value"].toLowerCase(),
      WorkPlaces:
        (formData.WorkPlaces &&
          Array.isArray(formData.WorkPlaces) &&
          formData.WorkPlaces.length > 0 &&
          formData.WorkPlaces.map((place) => place.id)) ||
        [],
      Ver: 1,
    };
    if (formData.Equipments.length > 0) {
      for (let i = 0; i < formData.Equipments.length; i++) {
        if (formData.Equipments[i]["Line"]) {
          linesStrIds += `${formData.Equipments[i]["Line"]["id"]},`;
        }
        if (formData.Equipments[i]["SAP"]) {
          equipmentsStrIds += `${formData.Equipments[i]["SAP"]["ID"]},`;
        }
      }
      linesStrIds = linesStrIds.slice(0, -1);
      equipmentsStrIds = equipmentsStrIds.slice(0, -1);
    }
    sendData[linesListName] = linesStrIds;
    sendData[equipmentsListName] = equipmentsStrIds;
    dispatch(
      addItem({
        listName: documentCodeIndexesListName,
        body: {
          Title: code,
          Index: indexDocumentNumber,
        },
      })
    );
    dispatch(addItem({ listName: myDocumentsListName, body: sendData }));
    setFiles(formData.File);
    setEquipments(formData.Equipments);
    setCode(`${sendData.Code}.${sendData.Index}`);
    setTitleNewDocument(formData.Title);
    setFormData(null);
    setStep(1);
  };

  useEffect(() => {
    setStatusTemplates("LOADING");
    getItemsRequest({
      listName: templatesLibName,
      sortOrder: { name: "SortColumn", asc: true },
    }).then((results) => {
      setTemplates([...results.items]);
      setStatusTemplates("SUCCESS");
    });
  }, []);

  useEffect(() => {
    if (
      Object.keys(loading).filter((key) => loading[key] === false).length === 0
    ) {
      setApprovers({});
      setFiles([]);
      setEquipments([]);
      setComment("");
      dispatch(addItemIdle({ listName: myDocumentsListName }));
      setLoading({
        add: false,
        approvers: false,
        equipments: false,
        document: false,
      });
      setTitleNewDocument("");
      setCloseAllModals(true);
      setCustomLoading(false);
      setHideCloseIcon(false);
      navigate(`/dashboard/1`);
      navigate(0);
    }
  }, [loading]);

  return (
    <DialogComponent
      type="add_card"
      hideCloseIcon={hideCloseIcon}
      setOpenCustomModal={setOpenCancelAddCard}
      open={open}
      toggleDialog={toggleDialog}
    >
      {(!customLoading && (
        <>
          {step === 1 && (
            <>
              <Step_1 templates={templates} statusTemplates={statusTemplates} />
              <div className="flex justify-between">
                <Button
                  open={openCancelAddCard}
                  setOpen={setOpenCancelAddCard}
                  classBg="btn-white"
                  shadow={true}
                  text="Отмена"
                />
                <Button
                  classBg="btn-dark"
                  text="Продолжить"
                  step={step}
                  setStep={setStep}
                />
              </div>
            </>
          )}
          {step === 2 && (
            <Step_2
              openCancelAddCard={openCancelAddCard}
              setOpenCancelAddCard={setOpenCancelAddCard}
              setFormData={setFormData}
              defaultValues={defaultValues}
              setIndexDocument={setIndexDocument}
              setIndexDocumentNumber={setIndexDocumentNumber}
              indexDocument={indexDocument}
            />
          )}
          {step === 3 && (
            <Step_3
              openCancelAddCard={openCancelAddCard}
              setOpenCancelAddCard={setOpenCancelAddCard}
              setApprovers={setApprovers}
              collection={formData.Collection["id"]}
              typeDocument={formData.DocType["id"]}
              setBackStep={setBackStep}
              backStep={backStep}
            />
          )}
          {openCancelAddCard && (
            <CancelAddCard
              open={openCancelAddCard}
              toggleDialog={dialogToggleCancelAddCard}
              setOpen={setOpenCancelAddCard}
              setCloseAllModals={setCloseAllModals}
              closeAllModals={closeAllModals}
            />
          )}
          {openSendCard && (
            <SendCard
              value={comment}
              addCardHandle={addCardHandle}
              setComment={setComment}
              open={openSendCard}
              toggleDialog={dialogToggleSendCard}
              setOpen={setOpenSendCard}
            />
          )}
        </>
      )) || (
          <FlexCol className="px-7.5 py-5 justify-center items-center gap-5">
            <span className="text-darkblue text-base">
              Добавляем документ
              <br />
              Пожалуйста подождите...
            </span>
            <Loading />
          </FlexCol>
        )}
    </DialogComponent>
  );
}
